import axios from "axios";
import React, { useState } from "react";
import ReactModal from "react-modal";
import Swal from "sweetalert2";

function EditaGestion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [archivo, setArchivo] = useState(null);

  const [postAccion, setPostAccion] = useState(props.acciones);
  const [postElemento, setPostElemento] = useState(props.elementos);
  const [postObservacion, setPostObservacion] = useState(props.observacion);

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "put",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaDetalleOm/" +
        props.idGestion,
      data: {
        accionMejora: postAccion || props.acciones,
        elementoVerificacion: postElemento || props.elementos,
        observacion: postObservacion || props.observacion,
        comentarios: props.comentarios || "",
      },
    })
      .then((Response) => {
        console.log(Response.data);
        Swal.fire({
          title: "Actualizado con éxito",
          text: "Haga clic para continuar",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload("/");
        });
      })
      .catch((error) => {
        console.log(error);
        alert("Error al actualizar: " + error);
      });
  };

  // Carga múltiple con SweetAlert
  const manejarCargaDocumentosRecursiva = async () => {
    const { value: file } = await Swal.fire({
      title: "Seleccione un documento",
      input: "file",
      inputAttributes: {
        accept: "*",
        "aria-label": "Cargue su documento",
      },
      showCancelButton: true,
      confirmButtonText: "Subir",
      cancelButtonText: "Cancelar",
    });

    if (file) {
      const formData = new FormData();
      formData.append("files", file);

      try {
        const response = await axios.post(
          `https://suadesarrollo.azurewebsites.net/api/ArchivosOM/${props.idOm}`,
          formData,
        );
        console.log("Archivo subido:", response.data);

        const continuar = await Swal.fire({
          title: "¿Desea anexar otro documento?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sí, agregar otro",
          cancelButtonText: "No, finalizar",
        });

        if (continuar.isConfirmed) {
          manejarCargaDocumentosRecursiva(); // Repetir carga
        } else {
          await Swal.fire(
            "Completado",
            "Carga de documentos finalizada.",
            "success",
          );
          window.location.reload(); // Recargar al terminar
        }
      } catch (error) {
        console.error("Error al subir archivo", error);
        Swal.fire("Error", "No se pudo subir el archivo.", "error");
      }
    } else {
      Swal.fire("Cancelado", "No se cargó ningún archivo.", "info");
    }
  };

  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Editar
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Editar Gestión"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Añadir Gestión OM #{props.idOm}
                  </h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <form className="user" onSubmit={postData}>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            type="text"
                            className="form-control form-control"
                            disabled
                            value={props.descripcion}
                          />
                          <hr />
                        </div>
                        <div className="col-sm-12">
                          <textarea
                            type="text"
                            className="form-control form-control"
                            placeholder="Acciones a implementar"
                            value={postAccion}
                            onChange={(e) => setPostAccion(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            type="text"
                            className="form-control form-control"
                            placeholder="Elementos de verificación"
                            value={postElemento}
                            onChange={(e) => setPostElemento(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            type="text"
                            className="form-control form-control"
                            placeholder="Observaciones"
                            value={postObservacion}
                            onChange={(e) => setPostObservacion(e.target.value)}
                          />
                        </div>
                      </div>

                      <br />
                      <button
                        className="btn btn-primary btn-user btn-block"
                        type="submit"
                      >
                        Guardar
                      </button>
                    </form>

                    <br />
                    <button
                      type="button"
                      className="btn btn-secondary btn-user btn-block"
                      onClick={manejarCargaDocumentosRecursiva}
                    >
                      Añadir documentos
                    </button>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default EditaGestion;
